var map = {
	"./music-instructions.json": 4831,
	"./music-library-intro2024.json": 4832,
	"./music-library-launch2024.json": 4833,
	"./music-progression.json": 4834,
	"./startSourcesAdvanced.json": 4835,
	"./startSourcesSimple.json": 4836,
	"./startSourcesSimple2.json": 4837,
	"./startSourcesTracks.json": 4838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4524;